import {
  EnumPoljaEvidencije,
  IAddress,
  IRecordPointClass,
  LoadFileType,
} from "../../../../redux/interfaces";

import config from "../../../../config";
import configMain from "../../../../config/config";
import moment from "moment";
import { paths } from "../../../../routes/paths";

export function getEarliestCreatedAt(
  recordPoint: IRecordPointClass,
  index: number
): Date {
  let dates: Date = new Date();
  if (recordPoint.CIPOEvd && recordPoint.CIPOEvd.length > 0) {
    const cipoEvd = recordPoint.CIPOEvd[index];
    if (cipoEvd && cipoEvd.datum) {
      const isoString = cipoEvd.datum.toString().replace(" ", "T");
      dates = new Date(isoString);
    }
  } else if (recordPoint.CIPPEvd && recordPoint.CIPPEvd.length > 0) {
    const cippEvd = recordPoint.CIPPEvd[index];
    if (cippEvd && cippEvd.datum) {
      const isoString = cippEvd.datum.toString().replace(" ", "T");
      dates = new Date(isoString);
    }
  } else if (
    recordPoint.DezinsekcijaEvd &&
    recordPoint.DezinsekcijaEvd.length > 0
  ) {
    dates = new Date(recordPoint.DezinsekcijaEvd[index].datum ?? "");
  } else if (
    recordPoint.DezinsekcijaEvd_Kontrola &&
    recordPoint.DezinsekcijaEvd_Kontrola.length > 0
  ) {
    dates = new Date(recordPoint.DezinsekcijaEvd_Kontrola[index].datum ?? "");
  } else if (
    recordPoint.DezinsekcijaEvd_Korekcija &&
    recordPoint.DezinsekcijaEvd_Korekcija.length > 0
  ) {
    dates = new Date(recordPoint.DezinsekcijaEvd_Korekcija[index].datum ?? "");
  } else if (
    recordPoint.DeratizacijaEvd &&
    recordPoint.DeratizacijaEvd.length > 0
  ) {
    dates = new Date(recordPoint.DeratizacijaEvd[index].datum ?? "");
  } else if (recordPoint.CheckListEvd && recordPoint.CheckListEvd.length > 0) {
    dates = new Date(recordPoint.CheckListEvd[index].datum ?? "");
  } else if (
    recordPoint.DeratizacijaEvd_Kontrola &&
    recordPoint.DeratizacijaEvd_Kontrola.length > 0
  ) {
    dates = new Date(recordPoint.DeratizacijaEvd_Kontrola[index].datum ?? "");
  } else if (
    recordPoint.DeratizacijaEvd_Korekcija &&
    recordPoint.DeratizacijaEvd_Korekcija.length > 0
  ) {
    dates = new Date(recordPoint.DeratizacijaEvd_Korekcija[index].datum ?? "");
  } else if (
    recordPoint.DezinfekcijaEvd &&
    recordPoint.DezinfekcijaEvd.length > 0
  ) {
    dates = new Date(recordPoint.DezinfekcijaEvd[index].datum ?? "");
  } else if (recordPoint.DezSrEvd && recordPoint.DezSrEvd.length > 0) {
    dates = new Date(recordPoint.DezSrEvd[index].createdAt);
  } else if (recordPoint.DobavljacEvd && recordPoint.DobavljacEvd.length > 0) {
    dates = new Date(recordPoint.DobavljacEvd[index].createdAt);
  } else if (recordPoint.MolEvd && recordPoint.MolEvd.length > 0) {
    recordPoint.MolEvd[index]?.datum ||
      (dates && (dates = new Date(recordPoint.MolEvd[index]?.datum || dates)));
  } else if (
    recordPoint.PrijemRobeEvd &&
    recordPoint.PrijemRobeEvd.length > 0
  ) {
    const prijemRobeEvd = recordPoint.PrijemRobeEvd[index];
    if (prijemRobeEvd?.datum) {
      const isoString = prijemRobeEvd.datum.toString().replace(" ", "T");
      const parsedDate = new Date(isoString);
      if (!isNaN(parsedDate.getTime())) {
        dates = parsedDate;
      }
    } else if (prijemRobeEvd?.createdAt) {
      dates = new Date(prijemRobeEvd.createdAt);
    }
  } else if (recordPoint.SanEvd && recordPoint.SanEvd.length > 0) {
    recordPoint.SanEvd[index].createdAt &&
      (dates = new Date(recordPoint.SanEvd[index].createdAt));
  } else if (recordPoint.OtpadEvd && recordPoint.OtpadEvd.length > 0) {
    recordPoint.OtpadEvd[index].createdAt &&
      (dates = new Date(recordPoint.OtpadEvd[index].datum ?? ""));
  } else if (
    recordPoint.TemperaturaEvd &&
    recordPoint.TemperaturaEvd.length > 0
  ) {
    const temperaturaEvd = recordPoint.TemperaturaEvd[index];
    if (temperaturaEvd && temperaturaEvd.datum) {
      const isoString = temperaturaEvd.datum.toString().replace(" ", "T");
      dates = new Date(isoString);
    }
  } else if (
    recordPoint.TemperaturaOgranicenaEvd &&
    recordPoint.TemperaturaOgranicenaEvd.length > 0
  ) {
    const temperaturaOgranicenaEvd =
      recordPoint.TemperaturaOgranicenaEvd[index];
    if (temperaturaOgranicenaEvd && temperaturaOgranicenaEvd.datum) {
      const isoString = temperaturaOgranicenaEvd.datum
        .toString()
        .replace(" ", "T");
      dates = new Date(isoString);
    }
  } else if (
    recordPoint.TemperaturaOgranicenaKKTEvd &&
    recordPoint.TemperaturaOgranicenaKKTEvd.length > 0
  ) {
    const temperaturaOgranicenaKKTEvd =
      recordPoint.TemperaturaOgranicenaKKTEvd[index];
    if (temperaturaOgranicenaKKTEvd && temperaturaOgranicenaKKTEvd.datum) {
      const isoString = temperaturaOgranicenaKKTEvd.datum
        .toString()
        .replace(" ", "T");
      dates = new Date(isoString);
    }
  } else if (
    recordPoint.TemperaturaKKTProizvodiEvd &&
    recordPoint.TemperaturaKKTProizvodiEvd.length > 0
  ) {
    const temperaturaKKTProizvodiEvd =
      recordPoint.TemperaturaKKTProizvodiEvd[index];
    if (temperaturaKKTProizvodiEvd && temperaturaKKTProizvodiEvd.datum) {
      const isoString = temperaturaKKTProizvodiEvd.datum
        .toString()
        .replace(" ", "T");
      dates = new Date(isoString);
    }
  } else if (recordPoint.OpremaEvd && recordPoint.OpremaEvd.length > 0) {
    recordPoint.OpremaEvd[index]?.datum ||
      (dates &&
        (dates = new Date(recordPoint.OpremaEvd[index]?.datum || dates)));
  } else if (recordPoint.EduZapEvd && recordPoint.EduZapEvd.length > 0) {
    recordPoint.EduZapEvd[index]?.datumObuke ||
      (dates &&
        (dates = new Date(recordPoint.EduZapEvd[index]?.datumObuke || dates)));
  } else if (recordPoint.DobavljacEvd && recordPoint.DobavljacEvd.length > 0) {
    recordPoint.DobavljacEvd[index].createdAt &&
      (dates = new Date(recordPoint.DobavljacEvd[index].createdAt));
  }

  return dates;
}

export function getImeIPrezime(
  recordPoint: IRecordPointClass,
  index: number
): string {
  let imeIPrezime: string = "";

  if (recordPoint.CIPOEvd && recordPoint.CIPOEvd.length > 0) {
    imeIPrezime = recordPoint.CIPOEvd[index]?.imePrezime
      ? recordPoint.CIPOEvd[index]?.imePrezime || ""
      : "";
  } else if (recordPoint.CIPPEvd && recordPoint.CIPPEvd.length > 0) {
    imeIPrezime = recordPoint.CIPPEvd[index]?.imePrezime
      ? recordPoint.CIPPEvd[index]?.imePrezime || ""
      : "";
  } else if (
    recordPoint.DezinfekcijaEvd &&
    recordPoint.DezinfekcijaEvd.length > 0
  ) {
    imeIPrezime = recordPoint.DezinfekcijaEvd[index]?.imePrezime
      ? recordPoint.DezinfekcijaEvd[index]?.imePrezime || ""
      : "";
  } else if (
    recordPoint.DezinsekcijaEvd &&
    recordPoint.DezinsekcijaEvd.length > 0
  ) {
    imeIPrezime = recordPoint.DezinsekcijaEvd[index]?.imePrezime
      ? recordPoint.DezinsekcijaEvd[index]?.imePrezime || ""
      : "";
  } else if (
    recordPoint.DezinsekcijaEvd_Kontrola &&
    recordPoint.DezinsekcijaEvd_Kontrola.length > 0
  ) {
    imeIPrezime = recordPoint.DezinsekcijaEvd_Kontrola[index]?.imePrezime
      ? recordPoint.DezinsekcijaEvd_Kontrola[index]?.imePrezime || ""
      : "";
  } else if (
    recordPoint.DezinsekcijaEvd_Korekcija &&
    recordPoint.DezinsekcijaEvd_Korekcija.length > 0
  ) {
    imeIPrezime = recordPoint.DezinsekcijaEvd_Korekcija[index]?.imePrezime
      ? recordPoint.DezinsekcijaEvd_Korekcija[index]?.imePrezime || ""
      : "";
  } else if (
    recordPoint.DeratizacijaEvd &&
    recordPoint.DeratizacijaEvd.length > 0
  ) {
    imeIPrezime = recordPoint.DeratizacijaEvd[index]?.imePrezime
      ? recordPoint.DeratizacijaEvd[index]?.imePrezime || ""
      : "";
  } else if (
    recordPoint.DeratizacijaEvd_Kontrola &&
    recordPoint.DeratizacijaEvd_Kontrola.length > 0
  ) {
    imeIPrezime = recordPoint.DeratizacijaEvd_Kontrola[index]?.imePrezime
      ? recordPoint.DeratizacijaEvd_Kontrola[index]?.imePrezime || ""
      : "";
  } else if (
    recordPoint.DeratizacijaEvd_Korekcija &&
    recordPoint.DeratizacijaEvd_Korekcija.length > 0
  ) {
    imeIPrezime = recordPoint.DeratizacijaEvd_Korekcija[index]?.imePrezime
      ? recordPoint.DeratizacijaEvd_Korekcija[index]?.imePrezime || ""
      : "";
  } else if (recordPoint.DobavljacEvd && recordPoint.DobavljacEvd.length > 0) {
    imeIPrezime = recordPoint.DobavljacEvd[index]?.imePrezime
      ? recordPoint.DobavljacEvd[index]?.imePrezime || ""
      : "";
  } else if (recordPoint.EduZapEvd && recordPoint.EduZapEvd.length > 0) {
    imeIPrezime = recordPoint.EduZapEvd[index]?.imePrezime
      ? recordPoint.EduZapEvd[index]?.imePrezime || ""
      : "";
  } else if (recordPoint.MolEvd && recordPoint.MolEvd.length > 0) {
    imeIPrezime = recordPoint.MolEvd[index]?.imePrezime
      ? recordPoint.MolEvd[index]?.imePrezime || ""
      : "";
  } else if (recordPoint.SanEvd && recordPoint.SanEvd.length > 0) {
    imeIPrezime = recordPoint.SanEvd[index]?.imePrezime
      ? recordPoint.SanEvd[index]?.imePrezime || ""
      : "";
  } else if (recordPoint.OpremaEvd && recordPoint.OpremaEvd.length > 0) {
    imeIPrezime = recordPoint.OpremaEvd[index]?.imePrezime
      ? recordPoint.OpremaEvd[index]?.imePrezime || ""
      : "";
  } else if (recordPoint.OtpadEvd && recordPoint.OtpadEvd.length > 0) {
    imeIPrezime = recordPoint.OtpadEvd[index]?.imePrezime
      ? recordPoint.OtpadEvd[index]?.imePrezime || ""
      : "";
  } else if (
    recordPoint.TemperaturaEvd &&
    recordPoint.TemperaturaEvd.length > 0
  ) {
    imeIPrezime = recordPoint.TemperaturaEvd[index]?.imePrezime
      ? recordPoint.TemperaturaEvd[index]?.imePrezime || ""
      : "";
  } else if (
    recordPoint.TemperaturaOgranicenaEvd &&
    recordPoint.TemperaturaOgranicenaEvd.length > 0
  ) {
    imeIPrezime = recordPoint.TemperaturaOgranicenaEvd[index]?.imePrezime
      ? recordPoint.TemperaturaOgranicenaEvd[index]?.imePrezime || ""
      : "";
  } else if (
    recordPoint.TemperaturaOgranicenaKKTEvd &&
    recordPoint.TemperaturaOgranicenaKKTEvd.length > 0
  ) {
    imeIPrezime = recordPoint.TemperaturaOgranicenaKKTEvd[index]?.imePrezime
      ? recordPoint.TemperaturaOgranicenaKKTEvd[index]?.imePrezime || ""
      : "";
  } else if (
    recordPoint.TemperaturaKKTProizvodiEvd &&
    recordPoint.TemperaturaKKTProizvodiEvd.length > 0
  ) {
    imeIPrezime = recordPoint.TemperaturaKKTProizvodiEvd[index]?.imePrezime
      ? recordPoint.TemperaturaKKTProizvodiEvd[index]?.imePrezime || ""
      : "";
  } else if (recordPoint.OpremaEvd && recordPoint.OpremaEvd.length > 0) {
    imeIPrezime = recordPoint.OpremaEvd[index]?.imePrezime
      ? recordPoint.OpremaEvd[index]?.imePrezime || ""
      : "";
  } else if (recordPoint.DezSrEvd && recordPoint.DezSrEvd.length > 0) {
    // imeIPrezime = recordPoint.DezSrEvd[index].userId?.toString()
    //   ? recordPoint.DezSrEvd[index].userId.toString()
    //   : "";

    imeIPrezime = "";
  } else if (recordPoint.DostavaEvd && recordPoint.DostavaEvd.length > 0) {
    imeIPrezime = recordPoint.DostavaEvd[index].posiljalac
      ? recordPoint.DostavaEvd[index].posiljalac || ""
      : "";
  } else if (
    recordPoint.PrijemRobeEvd &&
    recordPoint.PrijemRobeEvd.length > 0
  ) {
    imeIPrezime = recordPoint.PrijemRobeEvd[index].primalac
      ? recordPoint.PrijemRobeEvd[index].primalac || ""
      : "";
  } else if (recordPoint.CheckListEvd && recordPoint.CheckListEvd.length > 0) {
    imeIPrezime = recordPoint.CheckListEvd[index].imePrezime
      ? recordPoint.CheckListEvd[index].imePrezime || ""
      : "";
  }
  // Return the earliest date
  return imeIPrezime;
}

export function getPotpis(
  recordPoint: IRecordPointClass,
  index: number
): string {
  let potpis: string = "";
  if (recordPoint.CIPOEvd && recordPoint.CIPOEvd.length > 0) {
    potpis = recordPoint.CIPOEvd[index].potpisano
      ? recordPoint.CIPOEvd[index].potpisano || ""
      : "";
  } else if (recordPoint.CIPPEvd && recordPoint.CIPPEvd.length > 0) {
    potpis = recordPoint.CIPPEvd[index].potpisano
      ? recordPoint.CIPPEvd[index].potpisano || ""
      : "";
  } else if (
    recordPoint.DezinfekcijaEvd &&
    recordPoint.DezinfekcijaEvd.length > 0
  ) {
    potpis = recordPoint.DezinfekcijaEvd[index].potpisano
      ? recordPoint.DezinfekcijaEvd[index].potpisano || ""
      : "";
  } else if (
    recordPoint.DezinsekcijaEvd &&
    recordPoint.DezinsekcijaEvd.length > 0
  ) {
    potpis = recordPoint.DezinsekcijaEvd[index].potpisano
      ? recordPoint.DezinsekcijaEvd[index].potpisano || ""
      : "";
  } else if (
    recordPoint.DezinsekcijaEvd_Kontrola &&
    recordPoint.DezinsekcijaEvd_Kontrola.length > 0
  ) {
    potpis = recordPoint.DezinsekcijaEvd_Kontrola[index].potpisano
      ? recordPoint.DezinsekcijaEvd_Kontrola[index].potpisano || ""
      : "";
  } else if (
    recordPoint.DezinsekcijaEvd_Korekcija &&
    recordPoint.DezinsekcijaEvd_Korekcija.length > 0
  ) {
    potpis = recordPoint.DezinsekcijaEvd_Korekcija[index].potpisano
      ? recordPoint.DezinsekcijaEvd_Korekcija[index].potpisano || ""
      : "";
  } else if (
    recordPoint.DeratizacijaEvd &&
    recordPoint.DeratizacijaEvd.length > 0
  ) {
    potpis = recordPoint.DeratizacijaEvd[index].potpisano
      ? recordPoint.DeratizacijaEvd[index].potpisano || ""
      : "";
  } else if (
    recordPoint.DeratizacijaEvd_Kontrola &&
    recordPoint.DeratizacijaEvd_Kontrola.length > 0
  ) {
    potpis = recordPoint.DeratizacijaEvd_Kontrola[index].potpisano
      ? recordPoint.DeratizacijaEvd_Kontrola[index].potpisano || ""
      : "";
  } else if (
    recordPoint.DeratizacijaEvd_Korekcija &&
    recordPoint.DeratizacijaEvd_Korekcija.length > 0
  ) {
    potpis = recordPoint.DeratizacijaEvd_Korekcija[index].potpisano
      ? recordPoint.DeratizacijaEvd_Korekcija[index].potpisano || ""
      : "";
  } else if (recordPoint.DobavljacEvd && recordPoint.DobavljacEvd.length > 0) {
    potpis = recordPoint.DobavljacEvd[index].potpisano
      ? recordPoint.DobavljacEvd[index].potpisano || ""
      : "";
  } else if (recordPoint.MolEvd && recordPoint.MolEvd.length > 0) {
    potpis = recordPoint.MolEvd[index].potpisano
      ? recordPoint.MolEvd[index].potpisano || ""
      : "";
  } else if (
    recordPoint.PrijemRobeEvd &&
    recordPoint.PrijemRobeEvd.length > 0
  ) {
    potpis = recordPoint.PrijemRobeEvd[index].potpisano
      ? recordPoint.PrijemRobeEvd[index].potpisano || ""
      : "";
  } else if (recordPoint.SanEvd && recordPoint.SanEvd.length > 0) {
    potpis = recordPoint.SanEvd[index].potpisano
      ? recordPoint.SanEvd[index].potpisano || ""
      : "";
  } else if (recordPoint.OpremaEvd && recordPoint.OpremaEvd.length > 0) {
    potpis = recordPoint.OpremaEvd[index].potpisano
      ? recordPoint.OpremaEvd[index].potpisano || ""
      : "";
  } else if (recordPoint.OtpadEvd && recordPoint.OtpadEvd.length > 0) {
    potpis = recordPoint.OtpadEvd[index].potpisano
      ? recordPoint.OtpadEvd[index].potpisano || ""
      : "";
  } else if (
    recordPoint.TemperaturaEvd &&
    recordPoint.TemperaturaEvd.length > 0
  ) {
    potpis = recordPoint.TemperaturaEvd[index].potpisano
      ? recordPoint.TemperaturaEvd[index].potpisano || ""
      : "";
  } else if (
    recordPoint.TemperaturaOgranicenaEvd &&
    recordPoint.TemperaturaOgranicenaEvd.length > 0
  ) {
    potpis = recordPoint.TemperaturaOgranicenaEvd[index].potpisano
      ? recordPoint.TemperaturaOgranicenaEvd[index].potpisano || ""
      : "";
  } else if (
    recordPoint.TemperaturaOgranicenaKKTEvd &&
    recordPoint.TemperaturaOgranicenaKKTEvd.length > 0
  ) {
    potpis = recordPoint.TemperaturaOgranicenaKKTEvd[index].potpisano ?? "";
  } else if (
    recordPoint.TemperaturaKKTProizvodiEvd &&
    recordPoint.TemperaturaKKTProizvodiEvd.length > 0
  ) {
    potpis = recordPoint.TemperaturaKKTProizvodiEvd[index].potpisano ?? "";
  }
  if (recordPoint.CheckListEvd && recordPoint.CheckListEvd.length > 0) {
    return recordPoint.CheckListEvd[index].potpisano ?? "";
  }
  return formatBase64String(potpis);
}

const formatBase64String = (base64: string): string => {
  if (!base64 || !base64.trim()) return "";
  if (!base64.startsWith("data:image/")) {
    const withPrefix = `data:image/png;base64,${base64}`;
    // Reject if the payload part is missing or impossibly short for a real image
    const payload = withPrefix.split(",")[1] ?? "";
    if (payload.length < 50) return "";
    return withPrefix;
  }
  // Already has prefix — validate the payload
  const payload = base64.split(",")[1] ?? "";
  if (payload.length < 50) return "";
  return base64;
};

/** Safe guard for react-pdf <Image> src props. Returns "" for anything that
 *  would cause react-pdf to hang or throw (empty base64, broken URIs, etc.). */
export function safePdfImageSrc(src: string | null | undefined): string {
  if (!src) return "";
  if (src.startsWith("http://") || src.startsWith("https://")) return src;
  return formatBase64String(src);
}

export function getTipEvidencije(
  recordPoint: IRecordPointClass,
  index: number
): string {
  let potpis: string = "";
  if (recordPoint.CIPOEvd && recordPoint.CIPOEvd.length > 0) {
    potpis = recordPoint.CIPOEvd[index].type
      ? recordPoint.CIPOEvd[index].type
      : "";
  } else if (recordPoint.EduZapEvd && recordPoint.EduZapEvd.length > 0) {
    potpis = recordPoint.EduZapEvd[index].tip
      ? recordPoint.EduZapEvd[index].tip
      : "";
  } else if (recordPoint.OpremaEvd && recordPoint.OpremaEvd.length > 0) {
    potpis = recordPoint.OpremaEvd[index].tip
      ? recordPoint.OpremaEvd[index].tip || ""
      : "";
  }

  return potpis;
}

export function getSlikaDeklaracije(
  recordPoint: IRecordPointClass,
  index: number
): string | undefined {
  let potpis: string = "";
  if (recordPoint.DezinfekcijaEvd && recordPoint.DezinfekcijaEvd.length > 0) {
    const dezinsekcijaEvd = recordPoint.DezinfekcijaEvd?.[index];

    if (
      dezinsekcijaEvd?.slikaDeklaracije &&
      dezinsekcijaEvd.slikaDeklaracije.length > 0
    ) {
      const params = new URLSearchParams();
      params.append("type", EnumPoljaEvidencije.Dezinfekcija_V1);
      params.append(
        "id",
        recordPoint.DezinfekcijaEvd[index].dezinfekcijaEvdId.toString()
      );
      params.append("element", LoadFileType.IMAGE);

      potpis =
        configMain.frontendUrl +
        paths.lists.imagePage +
        "?\n" +
        params.toString();
    }
  } else if (
    recordPoint.DezinsekcijaEvd &&
    recordPoint.DezinsekcijaEvd.length > 0
  ) {
    const dezinsekcijaEvd = recordPoint.DezinsekcijaEvd?.[index];

    if (
      dezinsekcijaEvd?.slikaDeklaracije &&
      dezinsekcijaEvd.slikaDeklaracije.length > 0
    ) {
      const params = new URLSearchParams();
      params.append("type", EnumPoljaEvidencije.Dezinsekcija_V1);
      params.append(
        "id",
        recordPoint.DezinsekcijaEvd[index].dezinsekcijaEvdId.toString()
      );
      params.append("element", LoadFileType.IMAGE);

      potpis =
        configMain.frontendUrl +
        paths.lists.imagePage +
        "?\n" +
        params.toString();
    }
  } else if (
    recordPoint.DeratizacijaEvd &&
    recordPoint.DeratizacijaEvd.length > 0
  ) {
    const dezinsekcijaEvd = recordPoint.DeratizacijaEvd?.[index];

    if (
      dezinsekcijaEvd?.slikaDeklaracije &&
      dezinsekcijaEvd.slikaDeklaracije.length > 0
    ) {
      const params = new URLSearchParams();
      params.append("type", EnumPoljaEvidencije.Deratizacija_V1);
      params.append(
        "id",
        recordPoint.DeratizacijaEvd[index].deratizacijaEvdId.toString()
      );
      params.append("element", LoadFileType.IMAGE);

      potpis =
        configMain.frontendUrl +
        paths.lists.imagePage +
        "?\n" +
        params.toString();
    }
  } else if (
    recordPoint.DezSrEvd &&
    recordPoint.DezSrEvd.length > 0 &&
    recordPoint.DezSrEvd[index].slika
  ) {
    const dezinsekcijaEvd = recordPoint.DezSrEvd?.[index];

    if (dezinsekcijaEvd?.slika && dezinsekcijaEvd.slika.length > 0) {
      const params = new URLSearchParams();
      params.append("type", EnumPoljaEvidencije.DezSrEvd_V1);
      params.append("id", recordPoint.DezSrEvd[index].dezSrEvdId.toString());
      params.append("element", LoadFileType.IMAGE);

      potpis =
        configMain.frontendUrl +
        paths.lists.imagePage +
        "?\n" +
        params.toString();
    }
  }

  return potpis;
}

export function getStanjeKontrole(
  recordPoint: IRecordPointClass,
  index: number
): boolean {
  let potpis: boolean = false;
  if (
    recordPoint.DezinsekcijaEvd_Kontrola &&
    recordPoint.DezinsekcijaEvd_Kontrola.length > 0
  ) {
    potpis = recordPoint.DezinsekcijaEvd_Kontrola[index].stanjeKontrole
      ? recordPoint.DezinsekcijaEvd_Kontrola[index].stanjeKontrole || false
      : false;
  } else if (
    recordPoint.DeratizacijaEvd_Kontrola &&
    recordPoint.DeratizacijaEvd_Kontrola.length > 0
  ) {
    potpis = recordPoint.DeratizacijaEvd_Kontrola[index].stanjeKontrole
      ? recordPoint.DeratizacijaEvd_Kontrola[index].stanjeKontrole || false
      : false;
  } else if (recordPoint.DostavaEvd && recordPoint.DostavaEvd.length > 0) {
    potpis = recordPoint.DostavaEvd[index].ispravnaPosiljka
      ? recordPoint.DostavaEvd[index].ispravnaPosiljka || false
      : false;
  }

  return potpis;
}

export function getOpisKontrole(
  recordPoint: IRecordPointClass,
  index: number
): string {
  let potpis: string = "";
  if (
    recordPoint.DezinsekcijaEvd_Kontrola &&
    recordPoint.DezinsekcijaEvd_Kontrola.length > 0
  ) {
    potpis = recordPoint.DezinsekcijaEvd_Kontrola[index].opisKontrole
      ? recordPoint.DezinsekcijaEvd_Kontrola[index].opisKontrole || ""
      : "";
  } else if (
    recordPoint.DeratizacijaEvd_Kontrola &&
    recordPoint.DeratizacijaEvd_Kontrola.length > 0
  ) {
    potpis = recordPoint.DeratizacijaEvd_Kontrola[index].opisKontrole
      ? recordPoint.DeratizacijaEvd_Kontrola[index].opisKontrole || ""
      : "";
  }

  return potpis;
}

export function getBrojRacuna(
  recordPoint: IRecordPointClass,
  index: number
): string {
  let potpis: string = "";
  if (recordPoint.DostavaEvd && recordPoint.DostavaEvd.length > 0) {
    potpis = recordPoint.DostavaEvd[index].brojRacuna
      ? recordPoint.DostavaEvd[index].brojRacuna || ""
      : "";
  }

  return potpis;
}

export function getStanjeKorekcije(
  recordPoint: IRecordPointClass,
  index: number
): string {
  let potpis: string = "";
  if (
    recordPoint.DezinsekcijaEvd_Korekcija &&
    recordPoint.DezinsekcijaEvd_Korekcija.length > 0
  ) {
    potpis = recordPoint.DezinsekcijaEvd_Korekcija[index].stanjeKorekcije
      ? recordPoint.DezinsekcijaEvd_Korekcija[index].stanjeKorekcije || ""
      : "";
  } else if (
    recordPoint.DeratizacijaEvd_Korekcija &&
    recordPoint.DeratizacijaEvd_Korekcija.length > 0
  ) {
    potpis = recordPoint.DeratizacijaEvd_Korekcija[index].stanjeKorekcije
      ? recordPoint.DeratizacijaEvd_Korekcija[index].stanjeKorekcije || ""
      : "";
  }

  return potpis;
}

export function getOpisKorekcije(
  recordPoint: IRecordPointClass,
  index: number
): string {
  let potpis: string = "";
  if (
    recordPoint.DezinsekcijaEvd_Korekcija &&
    recordPoint.DezinsekcijaEvd_Korekcija.length > 0
  ) {
    potpis = recordPoint.DezinsekcijaEvd_Korekcija[index].opisKorekcije
      ? recordPoint.DezinsekcijaEvd_Korekcija[index].opisKorekcije || ""
      : "";
  } else if (
    recordPoint.DeratizacijaEvd_Korekcija &&
    recordPoint.DeratizacijaEvd_Korekcija.length > 0
  ) {
    potpis = recordPoint.DeratizacijaEvd_Korekcija[index].opisKorekcije
      ? recordPoint.DeratizacijaEvd_Korekcija[index].opisKorekcije || ""
      : "";
  }

  return potpis;
}

export function getNaziv(
  recordPoint: IRecordPointClass,
  index: number
): string {
  let potpis: string = "";
  if (recordPoint.DezSrEvd && recordPoint.DezSrEvd.length > 0) {
    potpis = recordPoint.DezSrEvd[index].naziv
      ? recordPoint.DezSrEvd[index].naziv || ""
      : "";
  } else if (recordPoint.DobavljacEvd && recordPoint.DobavljacEvd.length > 0) {
    potpis = recordPoint.DobavljacEvd[index].name
      ? recordPoint.DobavljacEvd[index].name || ""
      : "";
  }
  return potpis;
}

export function getOpis(recordPoint: IRecordPointClass, index: number): string {
  let potpis: string = "";
  if (recordPoint.MolEvd && recordPoint.MolEvd.length > 0) {
    potpis = recordPoint.MolEvd[index].opis
      ? recordPoint.MolEvd[index].opis || ""
      : "";
  } else if (recordPoint.OpremaEvd && recordPoint.OpremaEvd.length > 0) {
    potpis = recordPoint.OpremaEvd[index].opis
      ? recordPoint.OpremaEvd[index].opis || ""
      : "";
  }
  return potpis;
}

export function getUposlenik(
  recordPoint: IRecordPointClass,
  index: number
): string {
  let uposlenik: string = "";
  if (recordPoint.SanEvd && recordPoint.SanEvd.length > 0) {
    uposlenik = recordPoint.SanEvd[index].uposlenik
      ? recordPoint.SanEvd[index].uposlenik || ""
      : "";
  }
  return uposlenik;
}

export function getPrimjena(
  recordPoint: IRecordPointClass,
  index: number
): string {
  let potpis: string = "";
  if (recordPoint.DezSrEvd && recordPoint.DezSrEvd.length > 0) {
    potpis = recordPoint.DezSrEvd[index].primjena
      ? recordPoint.DezSrEvd[index].primjena || ""
      : "";
  }
  return potpis;
}

export function getUpustvoZaUpotrebu(
  recordPoint: IRecordPointClass,
  index: number
): string {
  let potpis: string = "";
  if (recordPoint.DezSrEvd && recordPoint.DezSrEvd.length > 0) {
    potpis = recordPoint.DezSrEvd[index].upustvoZaUpotrebu
      ? recordPoint.DezSrEvd[index].upustvoZaUpotrebu || ""
      : "";
  }
  return potpis;
}

export function getVrsta(
  recordPoint: IRecordPointClass,
  index: number
): string {
  let potpis: string = "";
  if (recordPoint.DezSrEvd && recordPoint.DezSrEvd.length > 0) {
    potpis = recordPoint.DezSrEvd[index].vrsta
      ? recordPoint.DezSrEvd[index].vrsta || ""
      : "";
  } else if (recordPoint.OtpadEvd && recordPoint.OtpadEvd.length > 0) {
    potpis = recordPoint.OtpadEvd[index].vrstaOtpada
      ? recordPoint.OtpadEvd[index].vrstaOtpada || ""
      : "";
  }
  return potpis;
}

export function getProdutType(
  recordPoint: IRecordPointClass,
  index: number
): string {
  let potpis: string = "";
  if (recordPoint.DobavljacEvd && recordPoint.DobavljacEvd.length > 0) {
    potpis = recordPoint.DobavljacEvd[index].productType
      ? recordPoint.DobavljacEvd[index].productType || ""
      : "";
  }
  return potpis;
}

export function getAddress(
  recordPoint: IRecordPointClass,
  index: number
): string {
  let potpis: string = "";
  if (recordPoint.DobavljacEvd && recordPoint.DobavljacEvd.length > 0) {
    var adresa: IAddress | undefined | null = recordPoint.DobavljacEvd[index]
      .address
      ? recordPoint.DobavljacEvd[index].address
      : undefined;
    if (adresa) {
      potpis =
        adresa.street +
        ", " +
        adresa.zipCode +
        " " +
        adresa.city +
        ", " +
        adresa.country;
    }
  }
  return potpis;
}

export function getIdTax(
  recordPoint: IRecordPointClass,
  index: number
): string {
  let potpis: string = "";
  if (recordPoint.DobavljacEvd && recordPoint.DobavljacEvd.length > 0) {
    potpis = recordPoint.DobavljacEvd[index].idTax
      ? recordPoint.DobavljacEvd[index].idTax || ""
      : "";
  }
  return potpis;
}

export function getPdvTax(
  recordPoint: IRecordPointClass,
  index: number
): string {
  let potpis: string = "";
  if (recordPoint.DobavljacEvd && recordPoint.DobavljacEvd.length > 0) {
    potpis = recordPoint.DobavljacEvd[index].pdvTax
      ? recordPoint.DobavljacEvd[index].pdvTax || ""
      : "";
  }
  return potpis;
}

export function getPhoneNumber(
  recordPoint: IRecordPointClass,
  index: number
): string {
  let potpis: string = "";
  if (recordPoint.DobavljacEvd && recordPoint.DobavljacEvd.length > 0) {
    potpis = recordPoint.DobavljacEvd[index].phoneNumber
      ? recordPoint.DobavljacEvd[index].phoneNumber || ""
      : "";
  }
  return potpis;
}

export function getExtraDate(
  recordPoint: IRecordPointClass,
  index: number,
  evdProperty?: string
): string | undefined {
  let potpis: string | undefined;

  const formatDateSafely = (
    dateValue: string | Date | null | undefined
  ): string | undefined => {
    if (!dateValue) return undefined;

    const dateDate = new Date(dateValue);
    if (isNaN(dateDate.getTime())) return undefined;

    const formattedDate = moment(dateDate).format(
      config.DATES_EVIDENCIJE.DATUMFORMAT
    );

    // Check if moment returned invalid date (NaN)
    if (formattedDate.includes("Invalid") || formattedDate.includes("NaN")) {
      return undefined;
    }

    return formattedDate;
  };

  // If evdProperty is provided, use it directly
  if (evdProperty) {
    const evdArray = recordPoint[evdProperty as keyof IRecordPointClass];
    if (Array.isArray(evdArray) && evdArray.length > index) {
      const evdItem = evdArray[index] as any;

      // For PrijemRobeEvd, try datum first (which is a timestamp containing both date and time)
      if (evdItem?.datum) {
        const formattedDatum = formatDateSafely(evdItem.datum);
        if (formattedDatum) {
          return formattedDatum;
        }
      }

      // Fallback to createdAt if datum is not available or invalid
      if (evdItem?.createdAt) {
        return formatDateSafely(evdItem.createdAt);
      }
    }
    return undefined;
  }

  // Fallback to sequential check if evdProperty is not provided
  if (recordPoint.CIPOEvd && recordPoint.CIPOEvd.length > 0) {
    potpis = formatDateSafely(recordPoint.CIPOEvd[index]?.datum);
  } else if (recordPoint.CIPPEvd && recordPoint.CIPPEvd.length > 0) {
    potpis = formatDateSafely(recordPoint.CIPPEvd[index]?.datum);
  } else if (
    recordPoint.DezinfekcijaEvd &&
    recordPoint.DezinfekcijaEvd.length > 0
  ) {
    potpis = formatDateSafely(recordPoint.DezinfekcijaEvd[index]?.datum);
  } else if (
    recordPoint.DezinsekcijaEvd &&
    recordPoint.DezinsekcijaEvd.length > 0
  ) {
    potpis = formatDateSafely(recordPoint.DezinsekcijaEvd[index]?.datum);
  } else if (
    recordPoint.DezinsekcijaEvd_Kontrola &&
    recordPoint.DezinsekcijaEvd_Kontrola.length > 0
  ) {
    potpis = formatDateSafely(
      recordPoint.DezinsekcijaEvd_Kontrola[index]?.datum
    );
  } else if (
    recordPoint.DezinsekcijaEvd_Korekcija &&
    recordPoint.DezinsekcijaEvd_Korekcija.length > 0
  ) {
    potpis = formatDateSafely(
      recordPoint.DezinsekcijaEvd_Korekcija[index]?.datum
    );
  } else if (
    recordPoint.DeratizacijaEvd &&
    recordPoint.DeratizacijaEvd.length > 0
  ) {
    potpis = formatDateSafely(recordPoint.DeratizacijaEvd[index]?.datum);
  } else if (
    recordPoint.DeratizacijaEvd_Kontrola &&
    recordPoint.DeratizacijaEvd_Kontrola.length > 0
  ) {
    potpis = formatDateSafely(
      recordPoint.DeratizacijaEvd_Kontrola[index]?.datum
    );
  } else if (
    recordPoint.DeratizacijaEvd_Korekcija &&
    recordPoint.DeratizacijaEvd_Korekcija.length > 0
  ) {
    potpis = formatDateSafely(
      recordPoint.DeratizacijaEvd_Korekcija[index]?.datum
    );
  } else if (recordPoint.DostavaEvd && recordPoint.DostavaEvd.length > 0) {
    potpis = formatDateSafely(recordPoint.DostavaEvd[index]?.datum);
  } else if (
    recordPoint.OpremaEvd &&
    recordPoint.OpremaEvd.length > 0 &&
    recordPoint.OpremaEvd[index]?.datum
  ) {
    potpis = formatDateSafely(recordPoint.OpremaEvd[index]?.datum);
  } else if (
    recordPoint.PrijemRobeEvd &&
    recordPoint.PrijemRobeEvd.length > 0 &&
    recordPoint.PrijemRobeEvd[index]?.datum
  ) {
    potpis = formatDateSafely(recordPoint.PrijemRobeEvd[index]?.datum);
  } else if (
    recordPoint.TemperaturaEvd &&
    recordPoint.TemperaturaEvd.length > 0 &&
    recordPoint.TemperaturaEvd[index]?.datum
  ) {
    potpis = formatDateSafely(recordPoint.TemperaturaEvd[index]?.datum);
  } else if (
    recordPoint.TemperaturaOgranicenaEvd &&
    recordPoint.TemperaturaOgranicenaEvd.length > 0 &&
    recordPoint.TemperaturaOgranicenaEvd[index]?.datum
  ) {
    potpis = formatDateSafely(
      recordPoint.TemperaturaOgranicenaEvd[index]?.datum
    );
  } else if (
    recordPoint.TemperaturaOgranicenaKKTEvd &&
    recordPoint.TemperaturaOgranicenaKKTEvd.length > 0 &&
    recordPoint.TemperaturaOgranicenaKKTEvd[index]?.datum
  ) {
    potpis = formatDateSafely(
      recordPoint.TemperaturaOgranicenaKKTEvd[index]?.datum
    );
  } else if (
    recordPoint.TemperaturaKKTProizvodiEvd &&
    recordPoint.TemperaturaKKTProizvodiEvd.length > 0 &&
    recordPoint.TemperaturaKKTProizvodiEvd[index]?.datum
  ) {
    potpis = formatDateSafely(
      recordPoint.TemperaturaKKTProizvodiEvd[index]?.datum
    );
  }

  return potpis;
}

export function getExtraVrijeme(
  recordPoint: IRecordPointClass,
  index: number,
  evdProperty?: string
): string | undefined {
  let potpis: string | undefined;

  // If evdProperty is provided, use it directly
  if (evdProperty) {
    const evdArray = recordPoint[evdProperty as keyof IRecordPointClass];
    if (Array.isArray(evdArray) && evdArray.length > index) {
      const evdItem = evdArray[index] as any;
      if (evdItem?.vrijeme) {
        potpis = evdItem.vrijeme.toString();
      }
    }
  } else {
    // Fallback to sequential check if evdProperty is not provided
    if (recordPoint.DostavaEvd && recordPoint.DostavaEvd.length > 0) {
      potpis = recordPoint.DostavaEvd[index]?.vrijeme?.toString();
    } else if (recordPoint.OpremaEvd && recordPoint.OpremaEvd.length > 0) {
      potpis = recordPoint.OpremaEvd[index]?.vrijeme?.toString();
    } else if (
      recordPoint.PrijemRobeEvd &&
      recordPoint.PrijemRobeEvd.length > 0
    ) {
      potpis = recordPoint.PrijemRobeEvd[index]?.vrijeme?.toString();
    } else if (
      recordPoint.TemperaturaEvd &&
      recordPoint.TemperaturaEvd.length > 0
    ) {
      potpis = recordPoint.TemperaturaEvd[index]?.vrijeme?.toString();
    }
  }

  // Return undefined if vrijeme is empty or invalid
  if (!potpis || potpis === "undefined" || potpis === "null") {
    return undefined;
  }

  return potpis;
}

export function getExtraVrijemeKorekcije(
  recordPoint: IRecordPointClass,
  index: number
): string | undefined {
  let potpis: string | undefined;
  if (recordPoint.TemperaturaEvd && recordPoint.TemperaturaEvd.length > 0) {
    potpis = recordPoint.TemperaturaEvd[index].vrijemeKorekcije
      ? recordPoint.TemperaturaEvd[index]?.vrijemeKorekcije?.toString()
      : undefined;
  }

  return potpis;
}

export function getdatumKorekcije(
  recordPoint: IRecordPointClass,
  index: number
): string | undefined {
  let potpis: string | undefined;
  if (recordPoint.TemperaturaEvd && recordPoint.TemperaturaEvd.length > 0) {
    potpis = recordPoint.TemperaturaEvd[index]?.datum
      ? recordPoint.TemperaturaEvd[index]?.datum?.toString()
      : undefined;
  }

  return potpis;
}

export function getPosiljalac(
  recordPoint: IRecordPointClass,
  index: number
): string {
  let potpis: string = "";
  if (recordPoint.DostavaEvd && recordPoint.DostavaEvd.length > 0) {
    potpis = recordPoint.DostavaEvd[index].posiljalac
      ? recordPoint.DostavaEvd[index].posiljalac || ""
      : "";
  } else if (
    recordPoint.PrijemRobeEvd &&
    recordPoint.PrijemRobeEvd.length > 0
  ) {
    potpis = recordPoint.PrijemRobeEvd[index].posiljalac
      ? recordPoint.PrijemRobeEvd[index].posiljalac || ""
      : "";
  }
  return potpis;
}

export function getpotpisPosiljalac(
  recordPoint: IRecordPointClass,
  index: number
): string {
  let potpis: string = "";
  if (recordPoint.DostavaEvd && recordPoint.DostavaEvd.length > 0) {
    potpis = recordPoint.DostavaEvd[index].potpisPosiljalac
      ? recordPoint.DostavaEvd[index].potpisPosiljalac || ""
      : "";
  } else if (recordPoint.MolEvd && recordPoint.MolEvd.length > 0) {
    potpis = recordPoint.MolEvd[index].potpisIzvrsioca
      ? recordPoint.MolEvd[index].potpisIzvrsioca || ""
      : "";
  } else if (
    recordPoint.PrijemRobeEvd &&
    recordPoint.PrijemRobeEvd.length > 0
  ) {
    potpis = recordPoint.PrijemRobeEvd[index].potpisPosiljalac
      ? recordPoint.PrijemRobeEvd[index].potpisPosiljalac || ""
      : "";
  } else if (recordPoint.OpremaEvd && recordPoint.OpremaEvd.length > 0) {
    potpis = recordPoint.OpremaEvd[index].potpisIzvrsioca
      ? recordPoint.OpremaEvd[index].potpisIzvrsioca || ""
      : "";
  }
  return potpis;
}

export function getPrimalac(
  recordPoint: IRecordPointClass,
  index: number
): string {
  let potpis: string = "";
  if (recordPoint.DostavaEvd && recordPoint.DostavaEvd.length > 0) {
    potpis = recordPoint.DostavaEvd[index].primalac
      ? recordPoint.DostavaEvd[index].primalac || ""
      : "";
  } else if (
    recordPoint.PrijemRobeEvd &&
    recordPoint.PrijemRobeEvd.length > 0
  ) {
    potpis = recordPoint.PrijemRobeEvd[index].primalac
      ? recordPoint.PrijemRobeEvd[index].primalac || ""
      : "";
  } else if (recordPoint.OtpadEvd && recordPoint.OtpadEvd.length > 0) {
    potpis = recordPoint.OtpadEvd[index].primaoc
      ? recordPoint.OtpadEvd[index].primaoc || ""
      : "";
  }

  return potpis;
}

export function getpotpisPrimalac(
  recordPoint: IRecordPointClass,
  index: number
): string {
  let potpis: string = "";
  if (recordPoint.DostavaEvd && recordPoint.DostavaEvd.length > 0) {
    potpis = recordPoint.DostavaEvd[index].potpisPrimalac
      ? recordPoint.DostavaEvd[index].potpisPrimalac || ""
      : "";
  } else if (
    recordPoint.PrijemRobeEvd &&
    recordPoint.PrijemRobeEvd.length > 0
  ) {
    potpis = recordPoint.PrijemRobeEvd[index].potpisPosiljalac
      ? recordPoint.PrijemRobeEvd[index].potpisPosiljalac || ""
      : "";
  } else if (recordPoint.OtpadEvd && recordPoint.OtpadEvd.length > 0) {
    potpis = recordPoint.OtpadEvd[index].potpisPrimaoc
      ? recordPoint.OtpadEvd[index].potpisPrimaoc || ""
      : "";
  }
  return potpis;
}

export function getDokument(
  recordPoint: IRecordPointClass,
  index: number
): string | undefined {
  let potpis = undefined;
  if (recordPoint.DostavaEvd && recordPoint.DostavaEvd.length > 0) {
    const dezinsekcijaEvd = recordPoint.DostavaEvd?.[index];

    if (dezinsekcijaEvd?.dokument && dezinsekcijaEvd.dokument.length > 0) {
      const params = new URLSearchParams();
      params.append("type", EnumPoljaEvidencije.DostavaEvd_V1);
      params.append(
        "id",
        recordPoint.DostavaEvd[index].dostavaEvdId.toString()
      );
      params.append("element", LoadFileType.IMAGE);

      potpis =
        configMain.frontendUrl +
        paths.lists.imagePage +
        "?\n" +
        params.toString();
    }
  } else if (recordPoint.EduZapEvd && recordPoint.EduZapEvd.length > 0) {
    const dezinsekcijaEvd = recordPoint.EduZapEvd?.[index];

    if (dezinsekcijaEvd?.dokument && dezinsekcijaEvd.dokument.length > 0) {
      const params = new URLSearchParams();
      params.append("type", EnumPoljaEvidencije.EduZapEvd_V1);
      params.append("id", recordPoint.EduZapEvd[index].eduZapEvdId.toString());
      params.append("element", LoadFileType.IMAGE);

      potpis =
        configMain.frontendUrl +
        paths.lists.imagePage +
        "?\n" +
        params.toString();
    }
  } else if (
    recordPoint.PrijemRobeEvd &&
    recordPoint.PrijemRobeEvd.length > 0
  ) {
    const dezinsekcijaEvd = recordPoint.PrijemRobeEvd?.[index];

    if (dezinsekcijaEvd?.dokument && dezinsekcijaEvd.dokument.length > 0) {
      const params = new URLSearchParams();
      params.append("type", EnumPoljaEvidencije.PrijemRobeEvd_V1);
      params.append(
        "id",
        recordPoint.PrijemRobeEvd[index].prijemRobeEvdId.toString()
      );
      params.append("element", LoadFileType.IMAGE);

      potpis =
        configMain.frontendUrl +
        paths.lists.imagePage +
        "?\n" +
        params.toString();
    }
  } else if (recordPoint.SanEvd && recordPoint.SanEvd.length > 0) {
    const dezinsekcijaEvd = recordPoint.SanEvd?.[index];

    if (dezinsekcijaEvd?.dokument && dezinsekcijaEvd.dokument.length > 0) {
      const params = new URLSearchParams();
      params.append("type", EnumPoljaEvidencije.SanEvd_V1);
      params.append("id", recordPoint.SanEvd[index].sanEvdId.toString());
      params.append("element", LoadFileType.IMAGE);

      potpis =
        configMain.frontendUrl +
        paths.lists.imagePage +
        "?\n" +
        params.toString();
    }
  } else if (recordPoint.CheckListEvd && recordPoint.CheckListEvd.length > 0) {
    const dezinsekcijaEvd = recordPoint.CheckListEvd?.[index];

    if (dezinsekcijaEvd?.dokument && dezinsekcijaEvd.dokument.length > 0) {
      const params = new URLSearchParams();
      params.append("type", EnumPoljaEvidencije.CheckListEvd_V1);
      params.append(
        "id",
        recordPoint.CheckListEvd[index].checkListEvdId.toString()
      );
      params.append("element", LoadFileType.IMAGE);

      potpis =
        configMain.frontendUrl +
        paths.lists.imagePage +
        "?\n" +
        params.toString();
    }
  }
  return potpis;
}

export function getCheckListPotpis(
  recordPoint: IRecordPointClass,
  index: number
): string {
  if (recordPoint.CheckListEvd && recordPoint.CheckListEvd.length > 0) {
    return recordPoint.CheckListEvd[index].potpisano || "";
  }
  return "";
}

export function getPrimjedba(
  recordPoint: IRecordPointClass,
  index: number
): string {
  let potpis: string = "";
  if (recordPoint.DostavaEvd && recordPoint.DostavaEvd.length > 0) {
    potpis = recordPoint.DostavaEvd[index].primjedba
      ? recordPoint.DostavaEvd[index].primjedba || ""
      : "";
  } else if (
    recordPoint.PrijemRobeEvd &&
    recordPoint.PrijemRobeEvd.length > 0
  ) {
    potpis = recordPoint.PrijemRobeEvd[index].primjedba
      ? recordPoint.PrijemRobeEvd[index].primjedba || ""
      : "";
  }
  return potpis;
}

export function getkorektivnaMjera(
  recordPoint: IRecordPointClass,
  index: number
): string {
  let potpis: string = "";
  if (recordPoint.DostavaEvd && recordPoint.DostavaEvd.length > 0) {
    potpis = recordPoint.DostavaEvd[index].korektivnaMjera
      ? recordPoint.DostavaEvd[index].korektivnaMjera || ""
      : "";
  } else if (
    recordPoint.PrijemRobeEvd &&
    recordPoint.PrijemRobeEvd.length > 0
  ) {
    potpis = recordPoint.PrijemRobeEvd[index].korektivnaMjera
      ? recordPoint.PrijemRobeEvd[index].korektivnaMjera || ""
      : "";
  } else if (recordPoint.OtpadEvd && recordPoint.OtpadEvd.length > 0) {
    potpis = recordPoint.OtpadEvd[index].korektivnaMjera
      ? recordPoint.OtpadEvd[index].korektivnaMjera || ""
      : "";
  }
  return potpis;
}

export function getTemperatura(
  recordPoint: IRecordPointClass,
  index: number
): string {
  let temperatura: string = "";
  if (recordPoint.PrijemRobeEvd && recordPoint.PrijemRobeEvd.length > 0) {
    temperatura = recordPoint.PrijemRobeEvd[index].temperatura
      ? recordPoint.PrijemRobeEvd[index].temperatura || ""
      : "";
  }
  return temperatura;
}

export function getDatumObuke(
  recordPoint: IRecordPointClass,
  index: number
): Date {
  let dates: Date = new Date();

  if (
    recordPoint.EduZapEvd &&
    recordPoint.EduZapEvd.length > 0 &&
    recordPoint.EduZapEvd[index]?.datumObuke
  ) {
    dates = new Date(recordPoint.EduZapEvd[index]?.datumObuke || dates);
  }
  return dates;
}

export function getVaziOd(recordPoint: IRecordPointClass, index: number): Date {
  let dates: Date = new Date();

  if (
    recordPoint.SanEvd &&
    recordPoint.SanEvd.length > 0 &&
    recordPoint.SanEvd[index].vaziOd
  ) {
    dates = new Date(recordPoint.SanEvd[index]?.vaziOd || "");
  }
  return dates;
}

export function getVaziDo(recordPoint: IRecordPointClass, index: number): Date {
  let dates: Date = new Date();

  if (
    recordPoint.SanEvd &&
    recordPoint.SanEvd.length > 0 &&
    recordPoint.SanEvd[index].vaziDo
  ) {
    dates = new Date(recordPoint.SanEvd[index]?.vaziDo || "");
  }
  return dates;
}

export function getCilj(recordPoint: IRecordPointClass, index: number): string {
  let potpis: string = "";
  if (recordPoint.EduZapEvd && recordPoint.EduZapEvd.length > 0) {
    potpis = recordPoint.EduZapEvd[index].cilj
      ? recordPoint.EduZapEvd[index].cilj || ""
      : "";
  }
  return potpis;
}

export function getizvrsilacObuke(
  recordPoint: IRecordPointClass,
  index: number
): string {
  let potpis: string = "";
  if (recordPoint.EduZapEvd && recordPoint.EduZapEvd.length > 0) {
    potpis = recordPoint.EduZapEvd[index].izvrsilacObuke
      ? recordPoint.EduZapEvd[index].izvrsilacObuke || ""
      : "";
  } else if (recordPoint.MolEvd && recordPoint.MolEvd.length > 0) {
    potpis = recordPoint.MolEvd[index].izvrsioc
      ? recordPoint.MolEvd[index].izvrsioc || ""
      : "";
  } else if (recordPoint.OpremaEvd && recordPoint.OpremaEvd.length > 0) {
    potpis = recordPoint.OpremaEvd[index].izvrsioc
      ? recordPoint.OpremaEvd[index].izvrsioc || ""
      : "";
  }
  return potpis;
}

export function getmjestoObuke(
  recordPoint: IRecordPointClass,
  index: number
): string {
  let potpis: string = "";
  if (recordPoint.EduZapEvd && recordPoint.EduZapEvd.length > 0) {
    potpis = recordPoint.EduZapEvd[index].mjestoObuke
      ? recordPoint.EduZapEvd[index].mjestoObuke || ""
      : "";
  }
  return potpis;
}

export function getRadnoMjesto(
  recordPoint: IRecordPointClass,
  index: number
): string {
  let potpis: string = "";
  if (recordPoint.EduZapEvd && recordPoint.EduZapEvd.length > 0) {
    potpis = recordPoint.EduZapEvd[index].radnoMjesto
      ? recordPoint.EduZapEvd[index].radnoMjesto || ""
      : "";
  }
  return potpis;
}

export function getTema(recordPoint: IRecordPointClass, index: number): string {
  let potpis: string = "";
  if (recordPoint.EduZapEvd && recordPoint.EduZapEvd.length > 0) {
    potpis = recordPoint.EduZapEvd[index].tema
      ? recordPoint.EduZapEvd[index].tema || ""
      : "";
  }
  return potpis;
}

export function getverifikacijaEdukatoraPotpis(
  recordPoint: IRecordPointClass,
  index: number
): string {
  let potpis: string = "";
  if (recordPoint.EduZapEvd && recordPoint.EduZapEvd.length > 0) {
    potpis = recordPoint.EduZapEvd[index].verifikacijaEdukatoraPotpis
      ? recordPoint.EduZapEvd[index].verifikacijaEdukatoraPotpis || ""
      : "";
  }
  return potpis;
}

export function getverifikacijaEfikasnosti(
  recordPoint: IRecordPointClass,
  index: number
): string {
  let potpis: string = "";
  if (recordPoint.EduZapEvd && recordPoint.EduZapEvd.length > 0) {
    potpis = recordPoint.EduZapEvd[index].verifikacijaEfikasnosti
      ? recordPoint.EduZapEvd[index].verifikacijaEfikasnosti || ""
      : "";
  }
  return potpis;
}

export function getverifikacijaPrisustvaPotpis(
  recordPoint: IRecordPointClass,
  index: number
): string {
  let potpis: string = "";
  if (recordPoint.EduZapEvd && recordPoint.EduZapEvd.length > 0) {
    potpis = recordPoint.EduZapEvd[index].verifikacijaPrisustvaPotpis
      ? recordPoint.EduZapEvd[index].verifikacijaPrisustvaPotpis || ""
      : "";
  }
  return potpis;
}

export function getKolicina(
  recordPoint: IRecordPointClass,
  index: number
): string {
  let potpis: number = 0;
  if (recordPoint.OtpadEvd && recordPoint.OtpadEvd.length > 0) {
    potpis = recordPoint.OtpadEvd[index].kolicina
      ? recordPoint.OtpadEvd[index].kolicina || 0
      : 0;
  }
  return potpis?.toString();
}

export function getjedinicaMjere(
  recordPoint: IRecordPointClass,
  index: number
): string {
  let potpis: string = "";
  if (recordPoint.OtpadEvd && recordPoint.OtpadEvd.length > 0) {
    potpis = recordPoint.OtpadEvd[index].jedinicaMjere
      ? recordPoint.OtpadEvd[index].jedinicaMjere || ""
      : "";
  }
  return potpis;
}

export function getocitanaTemperatura(
  recordPoint: IRecordPointClass,
  index: number
): number | null {
  let potpis: number | null = null;
  if (recordPoint.TemperaturaEvd && recordPoint.TemperaturaEvd.length > 0) {
    potpis = recordPoint.TemperaturaEvd[index].ocitanaTemperatura
      ? recordPoint.TemperaturaEvd[index].ocitanaTemperatura || null
      : null;
  } else if (
    recordPoint.TemperaturaOgranicenaEvd &&
    recordPoint.TemperaturaOgranicenaEvd.length > 0
  ) {
    potpis = recordPoint.TemperaturaOgranicenaEvd[index].ocitanaTemperatura
      ? recordPoint.TemperaturaOgranicenaEvd[index].ocitanaTemperatura || null
      : null;
  } else if (
    recordPoint.TemperaturaOgranicenaKKTEvd &&
    recordPoint.TemperaturaOgranicenaKKTEvd.length > 0
  ) {
    potpis = recordPoint.TemperaturaOgranicenaKKTEvd[index].ocitanaTemperatura
      ? recordPoint.TemperaturaOgranicenaKKTEvd[index].ocitanaTemperatura ||
        null
      : null;
  } else if (
    recordPoint.TemperaturaKKTProizvodiEvd &&
    recordPoint.TemperaturaKKTProizvodiEvd.length > 0
  ) {
    potpis = recordPoint.TemperaturaKKTProizvodiEvd[index].ocitanaTemperatura
      ? recordPoint.TemperaturaKKTProizvodiEvd[index].ocitanaTemperatura || null
      : null;
  }
  return potpis;
}

export function getdozvoljenaTempMin(
  recordPoint: IRecordPointClass,
  index: number
): number | null {
  let potpis: number | null = null;
  if (recordPoint.TemperaturaEvd && recordPoint.TemperaturaEvd.length > 0) {
    potpis = recordPoint.TemperaturaEvd[index].dozvoljenaTempMin
      ? recordPoint.TemperaturaEvd[index].dozvoljenaTempMin || null
      : null;
  } else if (
    recordPoint.TemperaturaOgranicenaEvd &&
    recordPoint.TemperaturaOgranicenaEvd.length > 0
  ) {
    potpis = recordPoint.RecordTraceConfig?.tempConfig?.dozvoljenaTempMin
      ? recordPoint.RecordTraceConfig?.tempConfig?.dozvoljenaTempMin
      : null;
  } else if (
    recordPoint.TemperaturaOgranicenaKKTEvd &&
    recordPoint.TemperaturaOgranicenaKKTEvd.length > 0
  ) {
    potpis = recordPoint.RecordTraceConfig?.tempConfig?.dozvoljenaTempMin
      ? recordPoint.RecordTraceConfig?.tempConfig?.dozvoljenaTempMin
      : null;
  } else if (
    recordPoint.TemperaturaKKTProizvodiEvd &&
    recordPoint.TemperaturaKKTProizvodiEvd.length > 0
  ) {
    potpis = recordPoint.RecordTraceConfig?.tempConfig?.dozvoljenaTempMin
      ? recordPoint.RecordTraceConfig?.tempConfig?.dozvoljenaTempMin
      : null;
  }
  return potpis;
}

export function getdozvoljenaTempMax(
  recordPoint: IRecordPointClass,
  index: number
): number | null {
  let potpis: number | null = null;
  if (recordPoint.TemperaturaEvd && recordPoint.TemperaturaEvd.length > 0) {
    potpis = recordPoint.TemperaturaEvd[index].dozvoljenaTempMax
      ? recordPoint.TemperaturaEvd[index].dozvoljenaTempMax || null
      : null;
  } else if (
    recordPoint.TemperaturaOgranicenaEvd &&
    recordPoint.TemperaturaOgranicenaEvd.length > 0
  ) {
    potpis = recordPoint.RecordTraceConfig?.tempConfig?.dozvoljenaTempMax
      ? recordPoint.RecordTraceConfig?.tempConfig?.dozvoljenaTempMax || null
      : null;
  } else if (
    recordPoint.TemperaturaOgranicenaKKTEvd &&
    recordPoint.TemperaturaOgranicenaKKTEvd.length > 0
  ) {
    potpis = recordPoint.RecordTraceConfig?.tempConfig?.dozvoljenaTempMax
      ? recordPoint.RecordTraceConfig?.tempConfig?.dozvoljenaTempMax || null
      : null;
  } else if (
    recordPoint.TemperaturaKKTProizvodiEvd &&
    recordPoint.TemperaturaKKTProizvodiEvd.length > 0
  ) {
    potpis = recordPoint.RecordTraceConfig?.tempConfig?.dozvoljenaTempMax
      ? recordPoint.RecordTraceConfig?.tempConfig?.dozvoljenaTempMax || null
      : null;
  }
  return potpis;
}

export function getdozvoljenoOdstupanje(
  recordPoint: IRecordPointClass,
  index: number
): number | null {
  let potpis: number | null = null;
  if (recordPoint.TemperaturaEvd && recordPoint.TemperaturaEvd.length > 0) {
    potpis = recordPoint.TemperaturaEvd[index].dozvoljenoOdstupanje
      ? recordPoint.TemperaturaEvd[index].dozvoljenoOdstupanje || null
      : null;
  } else if (
    recordPoint.TemperaturaOgranicenaEvd &&
    recordPoint.TemperaturaOgranicenaEvd.length > 0
  ) {
    potpis = recordPoint.RecordTraceConfig?.tempConfig?.dozvoljenoOdstupanje
      ? recordPoint.RecordTraceConfig?.tempConfig?.dozvoljenoOdstupanje || null
      : null;
  } else if (
    recordPoint.TemperaturaOgranicenaKKTEvd &&
    recordPoint.TemperaturaOgranicenaKKTEvd.length > 0
  ) {
    potpis = recordPoint.RecordTraceConfig?.tempConfig?.dozvoljenoOdstupanje
      ? recordPoint.RecordTraceConfig?.tempConfig?.dozvoljenoOdstupanje || null
      : null;
  } else if (
    recordPoint.TemperaturaKKTProizvodiEvd &&
    recordPoint.TemperaturaKKTProizvodiEvd.length > 0
  ) {
    potpis = recordPoint.RecordTraceConfig?.tempConfig?.dozvoljenoOdstupanje
      ? recordPoint.RecordTraceConfig?.tempConfig?.dozvoljenoOdstupanje || null
      : null;
  }
  return potpis;
}

export function getopisMjeereKorekcije(
  recordPoint: IRecordPointClass,
  index: number
): string {
  let potpis: string = "";
  if (recordPoint.TemperaturaEvd && recordPoint.TemperaturaEvd.length > 0) {
    potpis = recordPoint.TemperaturaEvd[index].opisMjeereKorekcije
      ? recordPoint.TemperaturaEvd[index]?.opisMjeereKorekcije || ""
      : "";
  }
  return potpis;
}

export function getocitanaTemperaturaKorekcije(
  recordPoint: IRecordPointClass,
  index: number
): number | null {
  let potpis: number | null = null;
  if (recordPoint.TemperaturaEvd && recordPoint.TemperaturaEvd.length > 0) {
    potpis = recordPoint.TemperaturaEvd[index].ocitanaTemperaturaKorekcije
      ? recordPoint.TemperaturaEvd[index].ocitanaTemperaturaKorekcije || null
      : null;
  }
  return potpis;
}

export function getdozvoljenaTempMinKorekcije(
  recordPoint: IRecordPointClass,
  index: number
): number | null {
  let potpis: number | null = null;
  if (recordPoint.TemperaturaEvd && recordPoint.TemperaturaEvd.length > 0) {
    potpis = recordPoint.TemperaturaEvd[index].dozvoljenaTempMinKorekcije
      ? recordPoint.TemperaturaEvd[index].dozvoljenaTempMinKorekcije || null
      : null;
  }
  return potpis;
}

export function getdozvoljenaTempMaxKorekcije(
  recordPoint: IRecordPointClass,
  index: number
): number | null {
  let potpis: number | null = null;
  if (recordPoint.TemperaturaEvd && recordPoint.TemperaturaEvd.length > 0) {
    potpis = recordPoint.TemperaturaEvd[index].dozvoljenaTempMaxKorekcije
      ? recordPoint.TemperaturaEvd[index].dozvoljenaTempMaxKorekcije || null
      : null;
  }
  return potpis;
}

export function getimePrezimeKorekcije(
  recordPoint: IRecordPointClass,
  index: number
): string {
  let potpis: string = "";
  if (recordPoint.TemperaturaEvd && recordPoint.TemperaturaEvd.length > 0) {
    potpis = recordPoint.TemperaturaEvd[index]?.imePrezimeKorekcije
      ? recordPoint.TemperaturaEvd[index]?.imePrezimeKorekcije || ""
      : "";
  }
  return potpis;
}

export function getpotpisIzvrsiocaKorekcije(
  recordPoint: IRecordPointClass,
  index: number
): string {
  let potpis: string = "";
  if (recordPoint.TemperaturaEvd && recordPoint.TemperaturaEvd.length > 0) {
    potpis = recordPoint.TemperaturaEvd[index].potpisIzvrsiocaKorekcije
      ? recordPoint.TemperaturaEvd[index].potpisIzvrsiocaKorekcije || ""
      : "";
  }
  return potpis;
}
export function getZadovoljenaKontrola(
  tempInput: number,
  minTemp?: number | null,
  maxTemp?: number | null,
  odstupanje?: number | null
): boolean {
  // If both minTemp and maxTemp are undefined, we'll consider any tempInput as valid.
  if (minTemp == null && maxTemp == null) {
    return true;
  }

  // Calculate effectiveMin and effectiveMax based on odstupanje if provided
  let effectiveMin: number = minTemp != null ? minTemp : -Infinity;
  let effectiveMax: number = maxTemp != null ? maxTemp : Infinity;

  if (odstupanje != null) {
    if (minTemp != null) {
      effectiveMin = minTemp - odstupanje;
    }
    if (maxTemp != null) {
      effectiveMax = maxTemp + odstupanje;
    }
  }

  return tempInput >= effectiveMin && tempInput <= effectiveMax;
}

export function getNapomena(
  recordPoint: IRecordPointClass,
  index: number
): string {
  let potpis: string = "";
  if (
    recordPoint.TemperaturaOgranicenaEvd &&
    recordPoint.TemperaturaOgranicenaEvd.length > 0
  ) {
    potpis = recordPoint.TemperaturaOgranicenaEvd[index].napomena
      ? recordPoint.TemperaturaOgranicenaEvd[index].napomena || ""
      : "";
  } else if (
    recordPoint.TemperaturaOgranicenaKKTEvd &&
    recordPoint.TemperaturaOgranicenaKKTEvd.length > 0
  ) {
    potpis = recordPoint.TemperaturaOgranicenaKKTEvd[index]
      .nakonKorekcijeTemperatura
      ? String(
          recordPoint.TemperaturaOgranicenaKKTEvd[index]
            .nakonKorekcijeTemperatura
        ) || ""
      : "";
  } else if (
    recordPoint.TemperaturaKKTProizvodiEvd &&
    recordPoint.TemperaturaKKTProizvodiEvd.length > 0
  ) {
    potpis = recordPoint.TemperaturaKKTProizvodiEvd[index].napomena
      ? recordPoint.TemperaturaKKTProizvodiEvd[index].napomena || ""
      : "";
  }
  return potpis;
}

export function getAdekvatnoPrikupljen(
  recordPoint: IRecordPointClass,
  index: number
): boolean {
  let adekvatnoPrikupljen: boolean = false;
  if (recordPoint.OtpadEvd && recordPoint.OtpadEvd.length > 0) {
    adekvatnoPrikupljen = recordPoint.OtpadEvd[index].adekvatnoPrikupljen
      ? true
      : false;
  } else if (
    recordPoint.TemperaturaOgranicenaKKTEvd &&
    recordPoint.TemperaturaOgranicenaKKTEvd.length > 0
  ) {
    adekvatnoPrikupljen = recordPoint.TemperaturaOgranicenaKKTEvd[index]
      .korektivnaMjera
      ? true
      : false;
  } else if (
    recordPoint.TemperaturaKKTProizvodiEvd &&
    recordPoint.TemperaturaKKTProizvodiEvd.length > 0
  ) {
    adekvatnoPrikupljen = recordPoint.TemperaturaKKTProizvodiEvd[index]
      .korektivnaMjera
      ? true
      : false;
  }

  return adekvatnoPrikupljen;
}

export function getProizvod(
  recordPoint: IRecordPointClass,
  index: number
): string {
  let adekvatnoPrikupljen: string = "";
  if (
    recordPoint.TemperaturaKKTProizvodiEvd &&
    recordPoint.TemperaturaKKTProizvodiEvd.length > 0
  ) {
    adekvatnoPrikupljen = recordPoint.TemperaturaKKTProizvodiEvd[index].proizvod
      ? recordPoint.TemperaturaKKTProizvodiEvd[index].proizvod || ""
      : "";
  }

  return adekvatnoPrikupljen;
}

/** Cap so react-pdf <Text> layout stays fast even for very long RTC descriptions. */
const PDF_DESCRIPTION_MAX_CHARS = 4000;

export async function getRichDescription(
  recordPoint: IRecordPointClass
): Promise<string> {
  if (!recordPoint?.RecordTraceConfig) return "";

  let description: string =
    recordPoint.RecordTraceConfig.descriptionMarkdown ?? "";

  if (description.length > PDF_DESCRIPTION_MAX_CHARS) {
    const cutoff = description.lastIndexOf("\n", PDF_DESCRIPTION_MAX_CHARS);
    description = description.slice(0, cutoff > 0 ? cutoff : PDF_DESCRIPTION_MAX_CHARS);
    description += "\n\n[...]";
  }

  return description;
}
